export default async (route, from, next, params) => {
  const router = params.router;
  const store = params.store;
  if (!store.getters['auth/isCompanyAdmin']) {
    console.log('is not company admin?');
  }
}
